import React, { useEffect, useState } from 'react'
import SubjectCard from '../../../components/subects/SubjectCard'
import xhr from '../../../utils/fetch'
import { CAUTION } from '../../../assets/images'
import { Bot, CodeIcon, Drum, MicVocal, Music2, School2 } from 'lucide-react'
import Carousels from '../../../components/Carousels'
import { Button } from '@wot/components'
import { useNavigate } from 'react-router-dom'


function SubjectsData() {
  const navigate = useNavigate();
    const [subjectCat,setSubjectCat] = useState([])
      useEffect(()=>{
        xhr({
          url:`/s/getAllCategories`,
          method:"GET"
        }).then(res=>(setSubjectCat(res.data)))
          .catch(err=>err)
    },[])
   const getIcon = (name:string) =>{
    if(name.toLowerCase() === ('non academy')){
      return School2
    }else if(name.toLowerCase() === 'coding'){
      return CodeIcon
    }else if(name.toLowerCase() === 'dance'){
      return Drum
    }else if(name.toLowerCase() === 'ai'){
      return Bot
    }else if(name.toLowerCase() === 'music'){
      return Music2
    }else if(name.toLowerCase() === 'public speaking'){
      return MicVocal
    }
   }
  return (<>
    <div className='md:grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 container  hidden gap-4 mx-auto'>
        {
            subjectCat.length > 0 ?( 
            subjectCat.slice(0, 8).map((item:any,indx)=>(
                <SubjectCard name={item.name} title={item.description} key={indx} id={item._id} icon={getIcon(item.name)}/>
            ))
        ):(
            <>
            <div className="flex flex-col gap-5 items-center py-10">
              <img src={CAUTION} alt="No subjects found" className="rounded-full" />
              <div className="flex flex-col items-center w-full gap-2">
                <span className="text-2xl font-medium">Oops,</span>
                <span className="w-full text-lg font-normal text-center">No Subject found.</span>
              </div>
             
            </div>
          </>
        )
        }
        
    </div>
   <div className='container md:hidden'>
   <Carousels>
              {
            subjectCat.length > 0 ?( 
              
            subjectCat.map((item:any,indx)=>(
                <SubjectCard name={item.name} title={item.description} key={indx} id={item._id} icon={getIcon(item.name)}/>
            ))
        ):(
            <>
            <div className="flex flex-col gap-5 items-center py-10">
              <img src={CAUTION} alt="No subjects found" className="rounded-full" />
              <div className="flex flex-col items-center w-full gap-2">
                <span className="text-2xl font-medium">Oops,</span>
                <span className="w-full text-lg font-normal text-center">No Subject found.</span>
              </div>
             
            </div>
          </>
        )
        }
    </Carousels>
   </div>
   <div>
    <Button text='explore more'  className='!px-12 !text-lg !bg-primary !border-primary mt-8 mx-auto flex' size='lg' onClick={()=>navigate('/explore')}/>
   </div>
  </>
  )
}

export default SubjectsData